exports = module.exports = require("../../../../../landing-page/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".equipment-chart .y-axis {\n  position: absolute;\n  margin-left: 15px;\n  margin-top: 5px;\n  line-height: 0;\n  text-align: right;\n  font-size: 10px;\n}\n\n.equipment-chart .auto-tick {\n  color: rgba(33, 202, 186, 0.5);\n}\n\n.equipment-chart .on-tick {\n  color: #21CABA;\n}\n\n.equipment-chart .off-tick {\n  color: #606671;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/css-loader!/Users/alextaxiera/source/farmhand-server/client/landing-page/~/postcss-loader/lib?{"plugins":[null]}!/Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/equipment-chart/index.css
// module id = ../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js?{"plugins":[null]}!../../../dashboard/src/js/components/equipment-chart/index.css
// module chunks = 0